import PinCodeInput from './PinCodeInput';

export default PinCodeInput;
